import React from 'react';
import PropTypes from 'prop-types';

import './VCFProfileCard.scss';
import FGBLabel from '../../../Elements/FGBLabel/FGBLabel';
import ResumeDownloadButton from '../../../Users/JobProfile/ResumeDownloadButton/ResumeDownloadButton';
import SVGFromCloudinary from '../../../Elements/SVGFromCloudinary/SVGFromCloudinary';

export default class VCFProfileCard extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        attendedVCFs: PropTypes.array,
        email: PropTypes.string,
        authorizedToWorkInUS: PropTypes.bool,
        requiresSponsorship: PropTypes.bool,
        isCurrentStudent: PropTypes.bool,
        yearsOfExperience: PropTypes.string,
    };

    static defaultProps = {};

    renderDisplaySection = (sectionInfo) => {
        return (
            <div className={`display-section ${sectionInfo.className}`}>
                <FGBLabel className={'black-font'}>
                    {sectionInfo.title}
                </FGBLabel>
                <div className="section-info-section">
                    {sectionInfo.value.map((item) => {
                        return <p className="section-description">{item}</p>;
                    })}
                </div>
            </div>
        );
    };

    convertBoolIntoYesOrNo = (bool) => {
        return bool === true ? 'Yes' : 'No';
    };

    createDownloadButton = ({ onClick }) => {
        const grayStyling = 'gray-styling';
        const buttonText = 'Download Resume';
        const downloadButtonSvg = (
            <SVGFromCloudinary
                cloudinaryID={'/v1583186537/Download_blue_madmls.svg'}
                className={'download-button-svg'}
            />
        );
        return (
            <button
                type="button"
                className={`download-btn ${grayStyling}`}
                onClick={onClick}
            >
                {downloadButtonSvg}
                {buttonText}
            </button>
        );
    };

    checkNullOrUndefined = (value) => {
        return value === undefined || value === null;
    };

    render() {
        const {
            attendedVCFs,
            email,
            authorizedToWorkInUS,
            requiresSponsorship,
            isCurrentStudent,
            yearsOfExperience,
            jobProfileHash,
        } = this.props;
        const values = {
            attendedVCFs: {
                title: 'source',
                value: attendedVCFs,
                className: 'vcf-styling',
            },
            email: {
                title: 'contact',
                value: [email],
                className: 'email-styling',
            },
            authorizedToWorkInUS: {
                title: 'Work Authorized In USA',
                value: [this.convertBoolIntoYesOrNo(authorizedToWorkInUS)],
                className: 'authorized-usa-styling',
            },
            requiresSponsorship: {
                title: 'Requires sponsorship',
                value: [this.convertBoolIntoYesOrNo(requiresSponsorship)],
                className: 'sponsorship-styling',
            },
            isCurrentStudent: {
                title: 'currently a student',
                value: [this.convertBoolIntoYesOrNo(isCurrentStudent)],
                className: 'isStudent-styling',
            },
            yearsOfExperience: {
                title: 'years of experience',
                value: [`${yearsOfExperience} years`],
                className: 'yearsOfExperience-styling',
            },
        };

        return (
            <div className="component-Employer-VCFPortal-VCFProfileCard">
                <h5 className="card-title">VRE attendee details:</h5>
                {attendedVCFs &&
                    attendedVCFs.length > 0 &&
                    this.renderDisplaySection(values.attendedVCFs)}
                <ResumeDownloadButton
                    userHash={jobProfileHash}
                    buttonElement={this.createDownloadButton}
                    metricType={'published-job-profile-download-resume-click'}
                />
                {email &&
                    email.length > 0 &&
                    this.renderDisplaySection(values.email)}
                {!this.checkNullOrUndefined(authorizedToWorkInUS) &&
                    this.renderDisplaySection(values.authorizedToWorkInUS)}
                {!this.checkNullOrUndefined(requiresSponsorship) &&
                    this.renderDisplaySection(values.requiresSponsorship)}
                {!this.checkNullOrUndefined(isCurrentStudent) &&
                    this.renderDisplaySection(values.isCurrentStudent)}
                {yearsOfExperience &&
                    yearsOfExperience.length > 0 &&
                    this.renderDisplaySection(values.yearsOfExperience)}
            </div>
        );
    }
}
